export enum FakturaStatus {
    Unknown = 'Unknown',
    PartiallyPayed = 'PartiallyPayed',
    Paid = 'Paid',
    Refunded = 'Refunded',
    AwaitingPayment = 'AwaitingPayment',
    AwaitingRefund = 'AwaitingRefund',
    Overdue = 'Overdue',
    Purring = 'Purring',
    Inkasso = 'Inkasso',
}
